"use client";
import React, { useEffect, useMemo, useState } from "react";
import { Box, Container, List, ListItem, Tab, Typography, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CruiseResults from "@/components/cruise-results/CruiseResults";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAppDispatch, useAppSelector } from "@/libs/hooks";
import Link from "next/link";
import MoreShipModal from "./MoreShipModal";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import SailingIcon from "@mui/icons-material/Sailing";
import PlaceIcon from "@mui/icons-material/Place";
import { IUniqCruise } from "@/interfaces/IUniqCruise";
import { IAllCruisesList } from "@/interfaces/IAllCruisesList";
import { setItems } from "@/slices/cruiesSlice";
import Image from "next/image";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import ReactPlayer from "react-player";
import { Contents } from "@/components/cruise-results/itinerary/CruiseFacilities";
import cruiselineJson from "@/assets/json/cruiseline.json";
interface UniqeCruiseProps {
  uniqeCruise: IUniqCruise | null;
  cruisedata: IAllCruisesList | null;
}

interface ICruiseContent {
  title?: string;
  idTitle?: string;
  subtitle?: string;
  id?: string;
  content?: string;
  fleet?: Fleet;
}

interface Fleet {
  map(arg0: (item: Fleet) => React.JSX.Element): React.ReactNode;
  title: string;
  ships: string[];
}

export const UniqeCruiseLine: React.FC<UniqeCruiseProps> = ({ uniqeCruise, cruisedata }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    try {
      dispatch(
        setItems({
          responce: cruisedata!,
        }),
      );
    } catch (err) {
      console.error(err);
    }
  }, [dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showMore = () => {
    setIsModalOpen(true);
  };

  const lessThanMD = useMediaQuery("(max-width:900px)");

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChangeExpension =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const shiptotal = uniqeCruise!.ships.length;
  const Region = useAppSelector((state) => state.cruies.availableRegions.length);
  const TotalCruise = useAppSelector((state) => state.cruies.originalAllResults.length);

  const [isReadMoreOpen, setIsReadMoreOpen] = useState(false);

  const vedioAvailable = useMemo(() => uniqeCruise?.videoUrl, [uniqeCruise]);
  const [sectionID, setSectionID] = useState("");
  const [seoContentAvailable, setSeoContentAvailable] = useState(false);

  const SEOcontent: ICruiseContent | undefined = useMemo(() => {
    const findcruise = cruiselineJson.find((cruise) => cruise.idTitle === uniqeCruise?.id);

    if (findcruise) {
      setSeoContentAvailable(true);
      return findcruise;
    } else {
      setSeoContentAvailable(false);
    }
    return {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const defaultTab = useMemo(
    () =>
      uniqeCruise?.description
        ? "1"
        : uniqeCruise?.membersClub
        ? "2"
        : uniqeCruise?.reasonsToBook
        ? "3"
        : seoContentAvailable && SEOcontent?.fleet
        ? "4"
        : "1",
    [SEOcontent?.fleet, seoContentAvailable, uniqeCruise],
  );

  const [value, setValue] = useState(defaultTab);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Box>
      <>
        {/* Hero  */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            mt: { md: "2rem" },
          }}
        >
          <Container sx={{ p: { xs: "0px", md: "0px 24px" } }}>
            <Grid container size={{ xs: 12 }} spacing={{ xs: 0.5, md: 3 }}>
              <Grid
                size={{
                  xs: 12,
                  md: seoContentAvailable && vedioAvailable ? 6.5 : vedioAvailable ? 6 : 12,
                }}
                order={{ xs: 2, md: 1 }}
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  zIndex: 4,
                }}
              >
                <Box
                  sx={{
                    p: { xs: "16px", md: "0px" },
                    bgcolor: { xs: "#fff", md: "transparent" },
                    width: { xs: "100%", md: "unset" },
                    borderRadius: "25px",
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "2rem", md: "3rem" },
                      fontWeight: { xs: 800, md: 700 },
                      textAlign: { xs: "center", md: "left" },
                      color: "primary.main",
                      lineHeight: { xs: 1.1, md: 1.3 },
                      mb: { xs: "10px", md: "0px" },

                      span: {
                        color: "transparent",
                        WebkitTextStrokeColor: "#CE0000",
                        WebkitTextStrokeWidth: "1px",
                      },
                    }}
                  >
                    {seoContentAvailable ? `${SEOcontent?.title}` : `${uniqeCruise!.title}`}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      justifyContent: { xs: "center", md: "flex-start" },
                      mb: "20px",
                      gap: "10px",
                      div: {
                        display: "flex",
                        alignItems: "center",
                        padding: "6px",
                        border: "1px solid #aaa",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                        svg: {
                          fontSize: "18px",
                          color: "#b0050f",
                          mr: "5px",
                        },
                        span: {
                          fontSize: "14px",
                          color: "primary.main",
                        },
                      },
                    }}
                  >
                    <Box>
                      <DirectionsBoatIcon /> <span> {shiptotal} ships </span>
                    </Box>
                    <Box>
                      <PlaceIcon /> <span>{Region} Region </span>
                    </Box>
                    <Box>
                      <SailingIcon /> <span>{TotalCruise} cruises</span>
                    </Box>
                  </Box>
                  {lessThanMD ? (
                    <>
                      <Box
                        sx={{
                          ".MuiPaper-root.MuiAccordion-root": {
                            boxShadow:
                              "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                            border: "2px solid #060273",
                            borderBottom: "5px solid #060273",
                            borderRadius: "15px !important",
                            mb: "1rem",
                            overflow: "hidden",
                          },
                          ".MuiButtonBase-root.MuiAccordionSummary-root": {
                            p: "4px 14px 2px",
                          },
                          ".MuiPaper-root.MuiAccordion-root::before": {
                            bgcolor: "unset",
                          },
                        }}
                      >
                        {uniqeCruise!.description && (
                          <Accordion
                            expanded={expanded === "panel1"}
                            onChange={handleChangeExpension("panel1")}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <Typography component="span" sx={{ flexShrink: 0 }}>
                                About cruise
                              </Typography>
                            </AccordionSummary>
                            {expanded === "panel1" && (
                              <AccordionDetails>
                                <Box
                                  sx={{
                                    strong: {
                                      color: "primary.main",
                                      fontWeight: 600,
                                    },
                                  }}
                                >
                                  <Contents
                                    data={
                                      seoContentAvailable
                                        ? SEOcontent.content
                                        : uniqeCruise!.description ?? ""
                                    }
                                    isReadMore={isReadMoreOpen}
                                    isCruiseLine
                                    sectionID={sectionID}
                                    setSectionID={setSectionID}
                                    setIsReadMore={setIsReadMoreOpen}
                                    onClick={() => {
                                      setIsReadMoreOpen((prev) => !prev);
                                      setSectionID("introduction");
                                    }}
                                    paragraphID={"introduction"}
                                  />
                                </Box>
                              </AccordionDetails>
                            )}
                          </Accordion>
                        )}

                        {(uniqeCruise?.ships?.length ?? 0) > 0 && (
                          <Accordion
                            expanded={expanded === "panel2"}
                            onChange={handleChangeExpension("panel2")}
                            sx={{ zIndex: 1 }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2bh-content"
                              id="panel2bh-header"
                            >
                              <Typography component="span" sx={{ width: "50%", flexShrink: 0 }}>
                                Meet Our Fleet
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ maxHeight: "300px", overflow: "auto" }}>
                              {uniqeCruise!.ships.map((ship, index) => (
                                <Link href={`/best-cruise-ships/${ship?.id}`} key={index}>
                                  <Box
                                    key={index}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "8px 16px 8px 0px",
                                      borderBottom: "1px solid #eee",
                                      "&:hover": {
                                        backgroundColor: "#f5f5f5",
                                      },
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: "1rem",
                                        fontWeight: 500,
                                        color: "text.primary",
                                      }}
                                    >
                                      {ship.name}
                                    </Typography>

                                    <Box
                                      sx={{
                                        position: "relative",
                                        width: "36px",
                                        height: "30px",
                                        borderRadius: "4px",
                                        overflow: "hidden",
                                      }}
                                    ></Box>
                                  </Box>
                                </Link>
                              ))}
                            </AccordionDetails>
                          </Accordion>
                        )}
                        {uniqeCruise!.membersClub && (
                          <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChangeExpension("panel3")}
                            sx={{ zIndex: 1 }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header"
                            >
                              <Typography component="span" sx={{ width: "50%", flexShrink: 0 }}>
                                Members Club
                              </Typography>
                            </AccordionSummary>
                            {expanded === "panel3" && (
                              <AccordionDetails>
                                <Box
                                  sx={{
                                    strong: {
                                      color: "primary.main",
                                      fontWeight: 600,
                                    },
                                  }}
                                >
                                  <Contents
                                    data={uniqeCruise!.membersClub ?? ""}
                                    isReadMore={isReadMoreOpen}
                                    isCruiseLine
                                    sectionID={sectionID}
                                    setSectionID={setSectionID}
                                    setIsReadMore={setIsReadMoreOpen}
                                    onClick={() => {
                                      setIsReadMoreOpen((prev) => !prev);
                                      setSectionID("members-club");
                                    }}
                                    paragraphID={"members-club"}
                                  />
                                </Box>
                              </AccordionDetails>
                            )}
                          </Accordion>
                        )}
                        {uniqeCruise!.reasonsToBook && (
                          <Accordion
                            expanded={expanded === "panel4"}
                            onChange={handleChangeExpension("panel4")}
                            sx={{
                              zIndex: 1,
                              mb: SEOcontent ? "16px !important" : "0px !important",
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography component="span" sx={{ width: "50%", flexShrink: 0 }}>
                                {/* What&apos;s included? */}
                                Discover More
                              </Typography>
                            </AccordionSummary>

                            {expanded === "panel4" && (
                              <AccordionDetails>
                                <Box
                                  sx={{
                                    strong: {
                                      color: "primary.main",
                                      fontWeight: 600,
                                    },
                                  }}
                                >
                                  <Contents
                                    data={uniqeCruise!.reasonsToBook ?? ""}
                                    isReadMore={isReadMoreOpen}
                                    isCruiseLine
                                    sectionID={sectionID}
                                    setSectionID={setSectionID}
                                    setIsReadMore={setIsReadMoreOpen}
                                    onClick={() => {
                                      setIsReadMoreOpen((prev) => !prev);
                                      setSectionID("reasons-to-book");
                                    }}
                                    paragraphID={"reasons-to-book"}
                                  />
                                </Box>
                              </AccordionDetails>
                            )}
                          </Accordion>
                        )}

                        {SEOcontent && (
                          <Accordion
                            expanded={expanded === "panel5"}
                            onChange={handleChangeExpension("panel5")}
                            sx={{ zIndex: 1, mb: "0px !important" }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel5bh-content"
                              id="panel5bh-header"
                            >
                              <Typography component="span" sx={{ width: "50%", flexShrink: 0 }}>
                                Fleet Overview
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                              <Box
                                sx={{
                                  strong: {
                                    color: "primary.main",
                                    fontWeight: 600,
                                  },
                                }}
                              >
                                {SEOcontent?.fleet?.map((item: Fleet) => (
                                  <React.Fragment key={item.title || Math.random().toString()}>
                                    <Box>
                                      <Typography variant="h6" gutterBottom>
                                        {item.title}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <List dense>
                                        {(() => {
                                          const ships = item.ships;
                                          const shipCount = ships.length;

                                          // Determine number of columns - adjust for mobile
                                          let columns = 1;
                                          if (shipCount > 10) {
                                            columns = window.innerWidth < 768 ? 2 : 3; // Fewer columns on mobile
                                          } else if (shipCount > 5) {
                                            columns = window.innerWidth < 768 ? 1 : 2; // Single column on mobile for smaller lists
                                          }

                                          if (columns === 1) {
                                            // Single column layout
                                            return ships.map((ship, index) => (
                                              <ListItem key={`${ship}-${index}`}>
                                                <Typography variant="body2">* {ship}</Typography>
                                              </ListItem>
                                            ));
                                          } else {
                                            // Multi-column layout
                                            const itemsPerColumn = Math.ceil(shipCount / columns);
                                            const columnArrays = [];

                                            for (let i = 0; i < columns; i++) {
                                              const startIndex = i * itemsPerColumn;
                                              const endIndex = Math.min(
                                                startIndex + itemsPerColumn,
                                                shipCount,
                                              );
                                              columnArrays.push(ships.slice(startIndex, endIndex));
                                            }

                                            return (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  gap: 2,
                                                  flexDirection: { xs: "column", sm: "row" }, // Stack on mobile
                                                }}
                                              >
                                                {columnArrays.map((column, columnIndex) => (
                                                  <Box
                                                    key={`column-${columnIndex}`}
                                                    sx={{ flex: 1 }}
                                                  >
                                                    {column.map((ship, shipIndex) => (
                                                      <ListItem
                                                        key={`${ship}-${columnIndex}-${shipIndex}`}
                                                        sx={{ py: 0.5 }}
                                                      >
                                                        <Typography variant="body2">
                                                          * {ship}
                                                        </Typography>
                                                      </ListItem>
                                                    ))}
                                                  </Box>
                                                ))}
                                              </Box>
                                            );
                                          }
                                        })()}
                                      </List>
                                    </Box>
                                  </React.Fragment>
                                ))}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Box>
                    </>
                  ) : seoContentAvailable ? (
                    <>
                      <Typography
                        component="span"
                        sx={{
                          width: "33%",
                          flexShrink: 0,
                          fontWeight: 600,
                          fontSize: { xs: "1.2rem", md: "1.5rem" },
                          textAlign: "left",
                          color: "primary.main",
                          fontFamily: "'blauerNue', 'blauerNue Fallback'",
                          mb: { xs: "10px", md: "0px" },
                        }}
                      >
                        {SEOcontent?.subtitle}
                      </Typography>

                      <Box
                        sx={{
                          strong: {
                            color: "primary.main",
                            fontWeight: 600,
                          },
                          mt: "8px",
                          "div > h3": {
                            mt: "0.5rem",
                          },
                          " div > h4": {
                            mt: "0.5rem",
                          },
                          "p + p": {
                            mt: "1rem",
                          },
                        }}
                      >
                        {SEOcontent?.content?.split("\n\n").map((paragraph, index) => (
                          <Typography key={index} component="p" paragraph>
                            {paragraph.trim()}
                          </Typography>
                        ))}
                      </Box>
                    </>
                  ) : (
                    uniqeCruise!.description && (
                      <Box>
                        <Typography
                          component="span"
                          sx={{
                            width: "33%",
                            flexShrink: 0,
                            fontWeight: 600,
                            fontSize: { xs: "1.2rem", md: "1.5rem" },
                            textAlign: "left",
                            color: "primary.main",
                            mb: { xs: "10px", md: "0px" },
                          }}
                        >
                          Overview
                        </Typography>

                        <Contents
                          data={uniqeCruise!.description ?? ""}
                          isReadMore={isReadMoreOpen}
                          isCruiseLine
                          sectionID={sectionID}
                          setSectionID={setSectionID}
                          setIsReadMore={setIsReadMoreOpen}
                          onClick={() => {
                            setIsReadMoreOpen((prev) => !prev);
                            setSectionID("introduction");
                          }}
                          paragraphID={"introduction"}
                        />
                      </Box>
                    )
                  )}
                </Box>
              </Grid>
              {vedioAvailable && (
                <Grid
                  size={{ xs: 12, md: seoContentAvailable ? 5.5 : 6 }}
                  order={{ xs: 1, md: 2 }}
                  sx={{ position: "relative", height: { xs: "200px", sm: "452px" } }}
                >
                  <HoverPlayYouTube videoUrl={uniqeCruise!.videoUrl} />
                </Grid>
              )}
            </Grid>
          </Container>
        </Box>

        <Box sx={{ mt: { xs: "2rem", md: "4rem" } }}>
          <Container sx={{ p: "0px auto" }}>
            <Grid container spacing={3}>
              <Grid
                size={{
                  xs: 12,
                  md:
                    uniqeCruise!.membersClub || uniqeCruise!.reasonsToBook
                      ? 6
                      : seoContentAvailable
                      ? 6
                      : 12,
                }}
              >
                {uniqeCruise!.ships.length > 0 && (
                  <>
                    <Grid size={{ xs: 12 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "20px",
                          alignItems: "center",
                          position: "relative",
                          mb: { xs: "1rem", md: "1.5rem" },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            // flexShrink: 0,
                            fontWeight: 600,
                            fontSize: { xs: "1.2rem", md: "1.5rem" },
                            textAlign: { xs: "center", md: "left" },
                            color: "primary.main",
                            fontFamily: "'blauerNue', 'blauerNue Fallback'",
                          }}
                        >
                          The fleet of{" "}
                          {seoContentAvailable ? `${SEOcontent?.title}` : `${uniqeCruise!.title}`}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid container spacing={{ xs: 2, md: 2 }}>
                      {uniqeCruise!.ships.slice(0, 4).map((m, i) => (
                        <Grid
                          size={{
                            xs: 6,
                          }}
                          key={i}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              height: { xs: "150px", md: "180px" },
                              borderColor: "primary.main",
                              boxShadow: "3px 0px 2px rgba(132, 181, 255, 0.3)",
                              borderRadius: "8px",
                              border: "1px solid #000",
                              overflow: "hidden",
                              p: "2rem",

                              img: {
                                width: { xs: "150px", md: "1800px" },
                                height: { xs: "150px", md: "1800px" },
                                objectFit: "cover",
                                display: "flex",
                              },
                              position: "relative",
                            }}
                          >
                            {i === uniqeCruise!.ships.slice(0, 4).length - 1 &&
                              (uniqeCruise?.ships?.length ?? 0) > 4 && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    background: "linear-gradient(45deg, #00000091, #00000030)",
                                    backdropFilter: "blur(4px)",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    zIndex: 1,
                                  }}
                                  onClick={showMore}
                                >
                                  <Box sx={{ textAlign: "center", padding: "1rem" }}>
                                    <Typography
                                      component={"span"}
                                      sx={{
                                        fontSize: "18px",
                                        fontFamily: "'blauerNue', 'blauerNue Fallback'",
                                        textShadow: "1px 1px 4px #909090",
                                        color: "#fff",
                                        fontWeight: 600,
                                      }}
                                    >
                                      View More {uniqeCruise?.ships.slice(3).length}+ Ships
                                    </Typography>
                                    <Box
                                      component={"span"}
                                      style={{ position: "relative", top: "3px", left: "4px" }}
                                    >
                                      <OpenInNewRoundedIcon
                                        sx={{ fontSize: "17px", color: "#fff" }}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              )}
                            <Link href={`/best-cruise-ships/${m?.id}`} key={i} aria-label={`View ${m?.name}`}>
                              {m.coverImageHref && (
                                <Image
                                  src={m.coverImageHref}
                                  fill
                                  alt={m?.name}
                                  loader={({ src }) => src}
                                  unoptimized
                                  style={{ borderRadius: "8px" }}
                                />
                              )}
                            </Link>
                            <Box
                              sx={{
                                bottom: "0.5rem",
                                left: 0,
                                position: "absolute",
                                py: "5px",
                                px: "0.5rem",
                                bgcolor: "#ffffff3b",
                                backdropFilter: "blur(5px)",
                                width: "100%",
                              }}
                            >
                              <Typography
                                variant="h5"
                                sx={{
                                  textAlign: "center",
                                  fontSize: { xs: "1rem", md: "1rem" },
                                  fontWeight: 400,
                                  mx: "8px",
                                  color: "#fff",
                                  textShadow:
                                    "1px 0px 1px black, 0px 1px 1px black, -1px 0px 1px black, 0px -1px 1px black",
                                }}
                              >
                                {m.name}
                              </Typography>{" "}
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
              </Grid>
              {(uniqeCruise?.membersClub || uniqeCruise?.reasonsToBook || seoContentAvailable) && (
                <Grid size={{ xs: 12, md: 6 }} sx={{ display: { xs: "none", md: "block" } }}>
                  <Box
                    sx={{
                      px: "0px !important",
                      width: "100%",
                      typography: "body1",
                      ".MuiTabPanel-root": {
                        px: "0px !important",
                      },
                      height: { xs: "400px", md: "435px" },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        flexShrink: 0,
                        fontWeight: 600,
                        fontSize: { xs: "1.2rem", md: "1.5rem" },
                        textAlign: "left",
                        color: "primary.main",
                        fontFamily: "'blauerNue', 'blauerNue Fallback'",
                        mb: { xs: "unset", md: "0.5rem" },
                      }}
                    >
                      Discover the Art of Cruising
                    </Typography>

                    <TabContext value={value}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange}
                          aria-label="cruise tabs"
                          sx={{ fontSize: "18px" }}
                        >
                          {uniqeCruise!.description && <Tab label="Overview" value="1" />}
                          {uniqeCruise!.membersClub && <Tab label="membersClub" value="2" />}
                          {uniqeCruise!.reasonsToBook && <Tab label="Facilities" value="3" />}
                          {seoContentAvailable && SEOcontent?.fleet && (
                            <Tab label="Fleet Overview" value="4" />
                          )}
                        </TabList>
                      </Box>

                      {uniqeCruise!.description && (
                        <TabPanel
                          value="1"
                          sx={{
                            height: "calc(100% - 90px)",
                            overflowY: "auto",
                          }}
                        >
                          <Typography
                            sx={{
                              strong: {
                                color: "primary.main",
                                fontWeight: 600,
                              },
                              ul: {
                                mt: "5px",
                                li: {
                                  mb: "7px",
                                  listStyle: "none",
                                  fontSize: "1rem",
                                  "&:before": {
                                    content: "'⚓︎'",
                                    position: "relative",
                                    top: "-1px",
                                    color: "#167ac6",
                                    pr: "0.5rem",
                                    ml: "0rem",
                                  },
                                },
                              },
                              "& h1": { fontSize: "16px" },
                              "div > p": {
                                "&:not(p:first-of-type)": {
                                  pt: "1rem",
                                },
                                b: {
                                  fontSize: "1.1rem",
                                },
                              },
                              "div > h3": {
                                mt: "0.5rem",
                              },
                              " div > h4": {
                                mt: "0.5rem",
                              },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: uniqeCruise!.description,
                            }}
                          />
                        </TabPanel>
                      )}
                      {uniqeCruise!.membersClub && (
                        <TabPanel
                          value="2"
                          sx={{
                            height: "calc(100% - 90px)",
                            overflowY: "auto",
                          }}
                        >
                          <Typography
                            sx={{
                              strong: {
                                color: "primary.main",
                                fontWeight: 600,
                              },
                              ul: {
                                mt: "5px",
                                li: {
                                  mb: "7px",
                                  listStyle: "none",
                                  fontSize: "1rem",
                                  "&:before": {
                                    content: "'⚓︎'",
                                    position: "relative",
                                    top: "-1px",
                                    color: "#167ac6",
                                    pr: "0.5rem",
                                    ml: "0rem",
                                  },
                                },
                              },
                              "div > p": {
                                "&:not(p:first-of-type)": {
                                  pt: "1rem",
                                },
                                b: {
                                  fontSize: "1.1rem",
                                },
                              },
                              "& h3": {
                                mt: "0.4rem",
                                mb: "0.4rem",
                              },
                              " * h4": {
                                mt: "0.5rem",
                              },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: uniqeCruise!.membersClub,
                            }}
                          />
                        </TabPanel>
                      )}

                      {uniqeCruise!.reasonsToBook && (
                        <TabPanel
                          value="3"
                          sx={{
                            height: "calc(100% - 90px)",
                            overflowY: "auto",
                          }}
                        >
                          <Typography
                            sx={{
                              strong: {
                                color: "primary.main",
                                fontWeight: 600,
                              },
                              ul: {
                                mt: "5px",
                                li: {
                                  mb: "7px",
                                  listStyle: "none",
                                  fontSize: "1rem",
                                  "&:before": {
                                    content: "'⚓︎'",
                                    position: "relative",
                                    top: "-1px",
                                    color: "#167ac6",
                                    pr: "0.5rem",
                                    ml: "0rem",
                                  },
                                },
                              },
                              "& p": {
                                "&:not(p:first-of-type)": {
                                  pt: "1rem",
                                },
                                b: {
                                  color: "primary.main",
                                  fontSize: "16px",
                                },
                              },
                              "& h3": {
                                color: "primary.main",
                                fontSize: "16px",
                                mt: "0.4rem",
                                mb: "0.4rem",
                                fontWeight: 600,
                              },
                              "& h4": {
                                color: "primary.main",
                                fontSize: "16px",
                                mb: "0.5rem",
                                fontWeight: 600,
                              },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: uniqeCruise!.reasonsToBook,
                            }}
                          />
                        </TabPanel>
                      )}
                      {SEOcontent && (
                        <TabPanel value="4" sx={{ height: "calc(100% - 90px)", overflowY: "auto" }}>
                          {SEOcontent?.fleet?.map((item: Fleet) => (
                            <React.Fragment key={item.title || Math.random().toString()}>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    color: "primary.main",
                                  }}
                                >
                                  {item.title}
                                </Typography>
                              </Box>
                              <Box>
                                <List dense>
                                  {(() => {
                                    const ships = item.ships;
                                    const shipCount = ships.length;

                                    // Determine number of columns
                                    let columns = 1;
                                    if (shipCount > 10) {
                                      columns = 3;
                                    } else if (shipCount > 5) {
                                      columns = 2;
                                    }

                                    if (columns === 1) {
                                      // Single column layout
                                      return ships.map((ship) => (
                                        <ListItem key={ship}>
                                          <Typography sx={{ fontSize: "16px" }}>
                                            * {ship}
                                          </Typography>
                                        </ListItem>
                                      ));
                                    } else {
                                      // Multi-column layout
                                      const itemsPerColumn = Math.ceil(shipCount / columns);
                                      const columnArrays = [];

                                      for (let i = 0; i < columns; i++) {
                                        const startIndex = i * itemsPerColumn;
                                        const endIndex = Math.min(
                                          startIndex + itemsPerColumn,
                                          shipCount,
                                        );
                                        columnArrays.push(ships.slice(startIndex, endIndex));
                                      }

                                      return (
                                        <Box sx={{ display: "flex", gap: 2 }}>
                                          {columnArrays.map((column, columnIndex) => (
                                            <Box key={columnIndex} sx={{ flex: 1 }}>
                                              {column.map((ship) => (
                                                <ListItem key={ship} sx={{ py: 0.5 }}>
                                                  <Typography sx={{ fontSize: "16px" }}>
                                                    * {ship}
                                                  </Typography>
                                                </ListItem>
                                              ))}
                                            </Box>
                                          ))}
                                        </Box>
                                      );
                                    }
                                  })()}
                                </List>
                              </Box>
                            </React.Fragment>
                          ))}
                        </TabPanel>
                      )}
                    </TabContext>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Container>
        </Box>

        {TotalCruise !== 0 && (
          <Box sx={{ mt: { xs: "2rem", md: "4rem" } }}>
            <Container sx={{ p: "0px auto" }}>
              <Typography
                variant="body2"
                sx={{
                  flexShrink: 0,
                  fontWeight: 600,
                  fontSize: { xs: "1.2rem", md: "1.5rem" },
                  textAlign: { xs: "center", md: "left" },
                  color: "primary.main",
                  fontFamily: "'blauerNue', 'blauerNue Fallback'",
                }}
              >
                Discover {TotalCruise} Unforgettable Journeys with {uniqeCruise!.title}
              </Typography>
            </Container>
            <CruiseResults Hidehero initialApiResponse={null} />
          </Box>
        )}
      </>
      <MoreShipModal open={isModalOpen} close={() => setIsModalOpen(false)} data={uniqeCruise} />
    </Box>
  );
};

const HoverPlayYouTube: React.FC<{ videoUrl: string }> = ({ videoUrl }) => {
  const [isHovering, setIsHovering] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      onMouseEnter={() => setIsHovering(true)}
      sx={{
        iframe: {
          boxShadow:
            "rgb(27 127 204 / 26%) 0px 10px 36px 0px, rgba(255, 255, 255, .2) 0px 0px 0px 1px",
          border: "2px solid #060273",
          borderRadius: "15px",
          "@media screen and (max-width:900px)": {
            width: "100%",
            position: "relative",
            borderRadius: "0px",
            border: "none",
            boxShadow: "unset",
          },
        },
      }}
    >
      <ReactPlayer
        url={videoUrl ?? ""}
        width="100%"
        height={isMobile ? "200px" : "452px"}
        config={{
          youtube: {
            playerVars: {
              modestbranding: 1,
              autoPlay: 1,
              rel: 0,
              fs: 0,
            },
          },
        }}
        controls={true}
        playing={isHovering ? true : false}
        playIcon={<></>}
        muted
        loop={true}
        volume={0}
      />
    </Box>
  );
};

export default UniqeCruiseLine;
